import { ReactNode, useEffect, useState } from 'react';
import { CopyIcon, ToolTip, StyledIconButton } from './CopyToClipboard.styles';

interface CopyToClipboardProps {
  value: string;
  onCopy?: () => void;
  className?: string;
  children?: ReactNode;
}

const CopyToClipboard = ({ value, onCopy, className, children }: CopyToClipboardProps) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    if (tooltipVisible) {
      setTimeout(() => {
        setTooltipVisible(false);
      }, 800);
    }
  }, [tooltipVisible]);

  const handleOnCopy = () => {
    navigator.clipboard.writeText(value);
    setTooltipVisible(true);
    if (onCopy) onCopy();
  };

  return (
    <StyledIconButton
      aria-label="Copy Button"
      onClick={handleOnCopy}
      className={className}
      disableRipple
    >
      {tooltipVisible && <ToolTip>Copied</ToolTip>}
      {children}
      <CopyIcon />
    </StyledIconButton>
  );
};

export default CopyToClipboard;
